import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import ConfigurationLocalAssaysProtocolsModalBasicForm
    from '@/modules/configurationModule/detail/local-assays/protocols/components/modal-basic-form/configuration-local-assays-protocols-modal-basic-form.vue'
import ConfigurationLocalAssaysProtocolsModalOntologiesForm
    from '@/modules/configurationModule/detail/local-assays/protocols/components/modal-ontologies-form/configuration-local-assays-protocols-modal-ontologies-form.vue'
import ConfigurationLocalAssaysProtocolsModalAssaysForm
    from '@/modules/configurationModule/detail/local-assays/protocols/components/modal-assays-form/configuration-local-assays-protocols-modal-assays-form.vue'
import {
    ConfigurationLocalAssaysProtocolsModalState,
    initialConfigurationLocalAssaysProtocolsModalState
} from '@/modules/configurationModule/detail/local-assays/protocols/components/modal/configuration-local-assays-protocols-modal.model'
import {
    ConfigurationProtocolCreateRequest,
    ConfigurationProtocolPatchInBatchRequest,
    ConfigurationProtocolResponse
} from '@/modules/configurationModule/detail/local-assays/protocols/services/configuration-protocol/configuration-protocol.dto'
import { BModal } from 'bootstrap-vue'

@Component({
    components: {
        ConfigurationLocalAssaysProtocolsModalBasicForm,
        ConfigurationLocalAssaysProtocolsModalOntologiesForm,
        ConfigurationLocalAssaysProtocolsModalAssaysForm
    }
})
export default class ConfigurationLocalAssaysProtocolsModal extends Vue {
    @Ref() readonly configurationLocalAssaysProtocolsModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Emit()
    create(): ConfigurationProtocolCreateRequest {
        return {
            active: !!this.state.protocol.active,
            name: this.state.protocol.name!,
            portionTypeId: this.state.protocol.portionType!.potId
        }
    }

    @Emit()
    update(): ConfigurationProtocolPatchInBatchRequest {
        return {
            id: this.state.protocol.id!,
            active: !!this.state.protocol.active,
            name: this.state.protocol.name,
            portionTypeId: this.state.protocol.portionType?.potId
        }
    }

    state: ConfigurationLocalAssaysProtocolsModalState

    get updateMode(): boolean {
        return !!this.state.protocol?.id
    }

    constructor() {
        super()

        this.state = initialConfigurationLocalAssaysProtocolsModalState()
    }

    async show(protocol?: ConfigurationProtocolResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationLocalAssaysProtocolsModalState()
        if (protocol) {
            this.state.protocol = { ...protocol }
        }

        this.configurationLocalAssaysProtocolsModal.show()
    }

    hide(): void {
        this.configurationLocalAssaysProtocolsModal.hide()
    }
}
